<template>
    <div v-if="view && !notification_view" class="notifications_push-wrap">
        <v-layout wrap
                  justify-space-around
                  align-start
                  class="notifications_block"
        >
            <div class="notifications_push__btn btn--icon snack_btn" @click="$emit('openHandler')">
                <svg class="icon">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/icons/sprite.svg#close" />
                </svg>
            </div>
            <v-flex row class="notifications__img-block"
                    xs3 ld2 md2
            >
                <div class="norifications_img" :style="{backgroundImage: 'url('+url+note.avatar+')'}">
                </div>
            </v-flex>
            <v-flex column class="notifications_body"
                    ld10
                    md10 xs12
                    style="cursor: pointer"
                    @click="goto_item(note)"
            >
                <v-layout row class="notifications__title-row" wrap
                          justify-space-between
                >
                    <v-flex row class="notifications__title"
                            ld6 md6 xs10
                            @click.native="goto_item(note)"
                    >
                        {{ note.title }}
                    </v-flex>
                    <v-flex ld6 md6 xs2>
                        <v-layout justify-start>
                            <v-flex row class="notifications__date mobile-hidden" justify-end
                                    xs4 ld6 md4
                            >
                                {{ note.date | day }}
                            </v-flex>
                            <v-flex xs4 md4>
                                <span class="notifications_time">
                                    {{ note.date | time }}
                                </span>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-flex row class="notifications__descr" md12
                        xs12
                >
                    <span @click="goto_page(note)" v-html="note.description"></span>
                </v-flex>
            </v-flex>
            <v-flex row class="notifications__descr descr-mobile" xs12>
                <span @click="goto_page(note)" v-html="note.description"></span>
            </v-flex>
        </v-layout>
    </div>
</template>


<script>
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
import dayjs from 'dayjs';

export default {
  props: {
    note: {
      type: Object,
    },
  },
  data() {
    return {
      view: true,
    };
  },
  computed: {
    notification_view() {
      const view = JSON.parse(localStorage.getItem('view'));
      return view ? view.includes(this.note.notification_id) : false;
    },
  },
  methods: {
    ...mapState('common', [
      'url',
    ]),
    close() {
      this.view = false;
      const id = JSON.parse(localStorage.getItem('view')) || [];
      id.push(this.note.notification_id);
      localStorage.setItem('view', JSON.stringify(id));
    },
    goto_item(item) {
      this.$router.push({name: 'notifications', hash: `#${item.notification_id}`});
      this.$store.state.isNew = true;
      this.$store.state.isOld = false;
      this.$store.state.id = item.notification_id;
    },
    ...mapMutations('news_main', ['SET_CURRENT_ID']),
    ...mapMutations('notifications/Notifications_items', ['SET_READ_MESSAGE', 'DELETE_READ_NOTE']),
    ...mapActions('notifications/Notifications_items', ['set_read_note']),
    /* close() {
      /!*this.set_read_note(this.note.notification_id);*!/
      this.DELETE_READ_NOTE(this.note);
    },*/
    goto_page(item) {
      const {id, link, notification_id} = item;

      this.SET_CURRENT_ID(notification_id);
      this.SET_READ_MESSAGE(item);
      this.DELETE_READ_NOTE(item);
      this.set_read_note(notification_id);
      this.$router.push({name: link, params: {id: id}});
    },
  },
};
</script>
